module.exports = __webpack_public_path__ + "teg/media/MultiMode.8858fdf5.jpg";